import { ReactElement } from 'react';

import {
  AutoRefreshLabel,
  PagePathLabel,
  Toolbar,
  ToolbarButton,
} from '../styles';

interface DebugToolbarProps {
  pagePath: string;
  state: { isLoading: boolean, isAutoRefreshOn: boolean };
  handlers: { onRefresh: () => void, onToggleAutoRefresh: (isOn: boolean) => void };
}

export const DebugToolbar = ({ pagePath, state, handlers }: Readonly<DebugToolbarProps>): ReactElement => (
  <Toolbar>
    <PagePathLabel>{`/admin/debug/${pagePath}`}</PagePathLabel>
    <AutoRefreshLabel>
      <input
        type="checkbox"
        checked={state.isAutoRefreshOn}
        onChange={(event) => handlers.onToggleAutoRefresh(event.target.checked)}
      />
      Atualização automática
    </AutoRefreshLabel>
    <ToolbarButton type="button" onClick={handlers.onRefresh} disabled={state.isLoading}>
      {state.isLoading ? 'Carregando...' : 'Atualizar'}
    </ToolbarButton>
  </Toolbar>
);
